import { createStore, StoreOptions } from 'vuex';
import { RootState } from '@/types/state/root';
import registration from './registration';
import registrationProcess from './registrationProcess';
import user from './user.js';
import lots from './lots.js';
import admin from './admin';
import appService from './appService.js';
import help from './help.js';
import contracts from './contracts.js';
import protocols from './protocols.js';
import supplyRequest from './supplyRequest.js';
import receiptOrder from './receiptOrder.js';
import supplyTask from './supplyTask.js';
import clarifications from './clarifications.js';
import notifications from './notifications.js';
import genContractorLots from './genContractorLots.js';
import contractWorksList from './contractWorksList.js';
import contractWorkDetail from './contractWorkDetail.js';
import contractWorkOffer from './contractWorkOffer.js';

const store: StoreOptions<RootState> = {
  modules: {
    appService,
    supplyRequest,
    receiptOrder,
    user,
    registration,
    registrationProcess,
    admin,
    lots,
    help,
    contracts,
    protocols,
    supplyTask,
    clarifications,
    notifications,
    genContractorLots,
    contractWorksList,
    contractWorkDetail,
    contractWorkOffer,
  },
};

export default createStore(store);
